/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";

import BaseLayout from "@/layouts/base-layout/index.vue";
import BlankLayout from "@/layouts/blank-layout/index.vue";

export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: BaseLayout,
  blank: BlankLayout,
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  "iframe-page": () => import("@/views/_builtin/iframe-page/[url].vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  about: () => import("@/views/about/index.vue"),
  "analytics_business-daily-report": () => import("@/views/analytics/business-daily-report/index.vue"),
  "analytics_daily-report-analysis": () => import("@/views/analytics/daily-report-analysis/index.vue"),
  "analytics_direct-supply-record": () => import("@/views/analytics/direct-supply-record/index.vue"),
  "analytics_measurement-tracking": () => import("@/views/analytics/measurement-tracking/index.vue"),
  "analytics_weighing-record-report": () => import("@/views/analytics/weighing-record-report/index.vue"),
  approval: () => import("@/views/approval/index.vue"),
  "base-goods_appointment": () => import("@/views/base-goods/appointment/index.vue"),
  "base-goods_inbound-images": () => import("@/views/base-goods/inbound-images/index.vue"),
  "base-goods_inbound-quality": () => import("@/views/base-goods/inbound-quality/index.vue"),
  "base-goods_inbound-weight": () => import("@/views/base-goods/inbound-weight/index.vue"),
  "base-goods_inbound": () => import("@/views/base-goods/inbound/index.vue"),
  "base-goods_outbound-images": () => import("@/views/base-goods/outbound-images/index.vue"),
  "base-goods_outbound-quality": () => import("@/views/base-goods/outbound-quality/index.vue"),
  "base-goods_outbound-weight": () => import("@/views/base-goods/outbound-weight/index.vue"),
  "base-goods_outbound": () => import("@/views/base-goods/outbound/index.vue"),
  "base-goods_purchase-waybill": () => import("@/views/base-goods/purchase-waybill/index.vue"),
  "base-goods_sales-waybill": () => import("@/views/base-goods/sales-waybill/index.vue"),
  basedata_customer: () => import("@/views/basedata/customer/index.vue"),
  basedata_driver: () => import("@/views/basedata/driver/index.vue"),
  "basedata_formula-lib": () => import("@/views/basedata/formula-lib/index.vue"),
  "basedata_product-name": () => import("@/views/basedata/product-name/index.vue"),
  "basedata_pub-master-corp": () => import("@/views/basedata/pub-master-corp/index.vue"),
  "basedata_pub-master-person": () => import("@/views/basedata/pub-master-person/index.vue"),
  basedata_supplier: () => import("@/views/basedata/supplier/index.vue"),
  "batch_batch-process": () => import("@/views/batch/batch-process/index.vue"),
  "contact-center": () => import("@/views/contact-center/index.vue"),
  contract_purchase_detail: () => import("@/views/contract/purchase/detail/index.vue"),
  contract_purchase: () => import("@/views/contract/purchase/index.vue"),
  contract_sales: () => import("@/views/contract/sales/index.vue"),
  contract_transport: () => import("@/views/contract/transport/index.vue"),
  "demo-route_child": () => import("@/views/demo-route/child/index.vue"),
  energy_management: () => import("@/views/energy/management/index.vue"),
  "finance_purchase-payment": () => import("@/views/finance/purchase-payment/index.vue"),
  "finance_sales-receipt": () => import("@/views/finance/sales-receipt/index.vue"),
  "function_hide-child_one": () => import("@/views/function/hide-child/one/index.vue"),
  "function_hide-child_three": () => import("@/views/function/hide-child/three/index.vue"),
  "function_hide-child_two": () => import("@/views/function/hide-child/two/index.vue"),
  "function_multi-tab": () => import("@/views/function/multi-tab/index.vue"),
  function_request: () => import("@/views/function/request/index.vue"),
  "function_super-page": () => import("@/views/function/super-page/index.vue"),
  function_tab: () => import("@/views/function/tab/index.vue"),
  "function_toggle-auth": () => import("@/views/function/toggle-auth/index.vue"),
  headquarters_contracts: () => import("@/views/headquarters/contracts/index.vue"),
  headquarters_statistics: () => import("@/views/headquarters/statistics/index.vue"),
  home: () => import("@/views/home/index.vue"),
  inventory_check: () => import("@/views/inventory/check/index.vue"),
  inventory_finished: () => import("@/views/inventory/finished/index.vue"),
  inventory_material: () => import("@/views/inventory/material/index.vue"),
  inventory_production: () => import("@/views/inventory/production/index.vue"),
  "invoice_purchase-invoice_in": () => import("@/views/invoice/purchase-invoice_in/index.vue"),
  "invoice_purchase-invoice_out": () => import("@/views/invoice/purchase-invoice_out/index.vue"),
  "invoice_sales-invoice": () => import("@/views/invoice/sales-invoice/index.vue"),
  "jin-sheng-lan_purchase-detail-ledger": () => import("@/views/jin-sheng-lan/purchase-detail-ledger/index.vue"),
  "jin-sheng-lan_sales-detail-ledger": () => import("@/views/jin-sheng-lan/sales-detail-ledger/index.vue"),
  "ledger_purchase-ledger-v2": () => import("@/views/ledger/purchase-ledger-v2/index.vue"),
  "ledger_purchase-ledger-v3-detail": () => import("@/views/ledger/purchase-ledger-v3-detail/index.vue"),
  "ledger_purchase-ledger-v3": () => import("@/views/ledger/purchase-ledger-v3/index.vue"),
  "ledger_purchase-ledger": () => import("@/views/ledger/purchase-ledger/index.vue"),
  "ledger_purchaser-settlement-center-leger-data_detail": () => import("@/views/ledger/purchaser-settlement-center-leger-data/detail/index.vue"),
  "ledger_purchaser-settlement-center-leger-data": () => import("@/views/ledger/purchaser-settlement-center-leger-data/index.vue"),
  "ledger_sales-ledger-v2": () => import("@/views/ledger/sales-ledger-v2/index.vue"),
  "ledger_sales-ledger-v3-detail": () => import("@/views/ledger/sales-ledger-v3-detail/index.vue"),
  "ledger_sales-ledger-v3": () => import("@/views/ledger/sales-ledger-v3/index.vue"),
  "ledger_sales-ledger": () => import("@/views/ledger/sales-ledger/index.vue"),
  "manage_approval-admin": () => import("@/views/manage/approval-admin/index.vue"),
  manage_dict: () => import("@/views/manage/dict/index.vue"),
  manage_menu: () => import("@/views/manage/menu/index.vue"),
  manage_notice: () => import("@/views/manage/notice/index.vue"),
  manage_org: () => import("@/views/manage/org/index.vue"),
  manage_position: () => import("@/views/manage/position/index.vue"),
  manage_role: () => import("@/views/manage/role/index.vue"),
  "manage_user-detail": () => import("@/views/manage/user-detail/[id].vue"),
  manage_user: () => import("@/views/manage/user/index.vue"),
  "millresident_unload-manifest": () => import("@/views/millresident/unload-manifest/index.vue"),
  monitor_cache: () => import("@/views/monitor/cache/index.vue"),
  monitor_file: () => import("@/views/monitor/file/index.vue"),
  monitor_logs_error: () => import("@/views/monitor/logs_error/index.vue"),
  monitor_logs_login: () => import("@/views/monitor/logs_login/index.vue"),
  monitor_logs_operation: () => import("@/views/monitor/logs_operation/index.vue"),
  monitor_logs_scheduler: () => import("@/views/monitor/logs_scheduler/index.vue"),
  monitor_scheduler: () => import("@/views/monitor/scheduler/index.vue"),
  monitor_system: () => import("@/views/monitor/system/index.vue"),
  "multi-menu_first_child": () => import("@/views/multi-menu/first_child/index.vue"),
  "multi-menu_second_child_home": () => import("@/views/multi-menu/second_child_home/index.vue"),
  "nonbase-goods_factory-images": () => import("@/views/nonbase-goods/factory-images/index.vue"),
  "nonbase-goods_factory-quality": () => import("@/views/nonbase-goods/factory-quality/index.vue"),
  "nonbase-goods_factory-weight": () => import("@/views/nonbase-goods/factory-weight/index.vue"),
  "nonbase-goods_measurement-tracking": () => import("@/views/nonbase-goods/measurement-tracking/index.vue"),
  "nonbase-goods_nonbase-waybill": () => import("@/views/nonbase-goods/nonbase-waybill/index.vue"),
  "nonbase-goods_nonbase": () => import("@/views/nonbase-goods/nonbase/index.vue"),
  "nonbase-goods_sales-detail-account": () => import("@/views/nonbase-goods/sales-detail-account/index.vue"),
  "nonbase-goods_steel-settlement": () => import("@/views/nonbase-goods/steel-settlement/index.vue"),
  "nonbase-goods_tracks-delivery_detail": () => import("@/views/nonbase-goods/tracks-delivery/detail/index.vue"),
  "nonbase-goods_tracks-delivery": () => import("@/views/nonbase-goods/tracks-delivery/index.vue"),
  "price_disposal-material": () => import("@/views/price/disposal-material/index.vue"),
  "price_material-maintenance": () => import("@/views/price/material-maintenance/index.vue"),
  price_material: () => import("@/views/price/material/index.vue"),
  "report_daily-business-report-2": () => import("@/views/report/daily-business-report-2/index.vue"),
  "report_daily-business-report-2_scrap-business-report": () => import("@/views/report/daily-business-report-2/scrap-business-report/index.vue"),
  "report_factory-daily-report": () => import("@/views/report/factory-daily-report/index.vue"),
  "report_measurement-daily-report": () => import("@/views/report/measurement-daily-report/index.vue"),
  "report_sales-performance": () => import("@/views/report/sales-performance/index.vue"),
  "report_scrap-business-report": () => import("@/views/report/scrap-business-report/index.vue"),
  "report_weekly-business-report": () => import("@/views/report/weekly-business-report/index.vue"),
  "settlement_purchase-settlement-center": () => import("@/views/settlement/purchase-settlement-center/index.vue"),
  "settlement_purchase-settlement": () => import("@/views/settlement/purchase-settlement/index.vue"),
  "settlement_purchase-settlement_review": () => import("@/views/settlement/purchase-settlement/review/index.vue"),
  "settlement_sales-settlement-center": () => import("@/views/settlement/sales-settlement-center/index.vue"),
  "settlement_sales-settlement": () => import("@/views/settlement/sales-settlement/index.vue"),
  "tools_generate-table": () => import("@/views/tools/generate-table/index.vue"),
  "unified-management_facility": () => import("@/views/unified-management/facility/index.vue"),
  "unified-management_files": () => import("@/views/unified-management/files/index.vue"),
  "unified-management_purchase": () => import("@/views/unified-management/purchase/index.vue"),
  "unified-management_sales": () => import("@/views/unified-management/sales/index.vue"),
  "user-center": () => import("@/views/user-center/index.vue"),
};
